import { render, staticRenderFns } from "./ProfitValue.vue?vue&type=template&id=6fd13042&"
import script from "./ProfitValue.vue?vue&type=script&lang=ts&"
export * from "./ProfitValue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports